export default __webpack_public_path__ + "static/media/25101703.bcafdfa4.jpg";